import GoBackButton from '@/components/GoBackButton';
import ConnectWalletButton from '@/components/Header/connectWallet';
import LazbubuDrawer from '@/components/LazbubuDrawer';
import { useLazbubu } from '@/hooks/useLazbubu';
import application from '@/stores/application';
import user from '@/stores/user';
import CircularProgress from '@mui/material/CircularProgress';
import { observer } from 'mobx-react';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { LazbubuIncubator } from '../UI';
import Adventure from './Adventure';
import Chat from './Chat';
import Memory from './Memory';

const Play: React.FC = observer(() => {
    const params: any = useParams();
    const { lazbubu, error } = useLazbubu(Number(params.id));
    const { connected: userConnected, address: walletAddress } = user;

    const [activeTab, setActiveTab] = useState<'chat' | 'adventure' | 'memory'>(
        'chat',
    );

    return (
        <div className="flex flex-col items-center justify-center relative mt-[20px] px-[40px] max-md:px-[20px]">
            <GoBackButton
                className={`${
                    !application.isExploreNavDrawerOpen
                        ? 'left-[100px]'
                        : 'left-[280px]'
                } fixed top-[100px] max-md:top-[80px] max-md:left-[20px]`}
            />
            {!userConnected ? (
                <div className="mt-[100px]">
                    <ConnectWalletButton
                        connected={userConnected}
                        walletAddress={walletAddress || ''}
                    />
                </div>
            ) : lazbubu ? (
                <>
                    <LazbubuIncubator lazbubu={lazbubu} />
                    <div className="flex gap-[10px] my-[20px]">
                        <div
                            className={`px-[20px] py-[10px] rounded-[16px] text-[14px] cursor-pointer ${
                                activeTab === 'chat'
                                    ? 'bg-primary text-white'
                                    : 'bg-white'
                            }`}
                            onClick={() => setActiveTab('chat')}
                        >
                            Chat
                        </div>
                        <div
                            className={`px-[20px] py-[10px] rounded-[16px] text-[14px] cursor-pointer ${
                                activeTab === 'adventure'
                                    ? 'bg-primary text-white'
                                    : 'bg-white'
                            }`}
                            onClick={() => setActiveTab('adventure')}
                        >
                            Adventure
                        </div>
                        <div
                            className={`px-[20px] py-[10px] rounded-[16px] text-[14px] cursor-pointer ${
                                activeTab === 'memory'
                                    ? 'bg-primary text-white'
                                    : 'bg-white'
                            }`}
                            onClick={() => setActiveTab('memory')}
                        >
                            Memory
                        </div>
                    </div>
                    {activeTab === 'chat' && <Chat lazbubu={lazbubu} />}
                    {activeTab === 'adventure' && (
                        <Adventure lazbubu={lazbubu} />
                    )}
                    {activeTab === 'memory' && <Memory lazbubu={lazbubu} />}
                    <LazbubuDrawer lazbubu={lazbubu} />
                </>
            ) : error ? (
                <div className="mt-[100px] flex flex-col items-center gap-[20px]">
                    <p className="text-[14px] text-center text-gray-600">
                        Something went wrong. Please refresh the page to try
                        again.
                    </p>
                    <button
                        onClick={() => window.location.reload()}
                        className="px-[20px] py-[10px] bg-primary text-white rounded-[8px] text-[14px] hover:bg-primary/80 transition-colors"
                    >
                        Refresh Page
                    </button>
                </div>
            ) : (
                <CircularProgress className="mt-[100px]" thickness={6} />
            )}
        </div>
    );
});

export default Play;
